import React from 'react';
import {Link} from "react-router-dom";
import SelectContractContainer from "../../../../../Commun/SelectContract/SelectContractContainer";
import _ from "lodash";
import APILink from "../../../../../Commun/APILink/APILink.jsx";
import FormReleveInformation
    from "../../Questions/ListeQuestions/Components/ReleveInformation/FormReleveInformation/FormReleveInformation.jsx";
import Swal from "sweetalert2";
import moment from "moment";

const ListeDocuments = (props) => {
    const { quittance, contract } = props
    const isTransitoire = contract?.old_vehicule && contract?.vehicule?.transitoire === 'T' && contract?.vehicule?.vente_old_vehicule === 'F' && moment(contract?.old_vehicule?.date_fin_piece).isAfter(moment());
    const handleClickInfo = () => {
        Swal.fire({
            icon: '',
            title: '',
            text: 'Ce véhicule bénéficie des mêmes garanties et options que celles de votre nouveau véhicule, uniquement s\'il est mis en circulation pour des essais en vue de la vente et pour une durée maximale de 30 jours.',
            showConfirmButton: true,
            confirmButtonText: 'Ok',
            showCloseButton: true
        })
    }

    return (
        <div>
            <div className={'mt-5 pb-2'}>
                <h1 className={'fw-bold'}><Link to={'/'}><i className="bi bi-arrow-left-circle me-2" /></Link>Mes documents</h1>
            </div>

            <SelectContractContainer>
                {
                    !_.includes(['6', '5', 'I'], contract.situation?.statutCode) && quittance && <>
                        {(quittance?.memo_link && !_.isEmpty(contract.vehicule.immatriculation)) &&
                            <APILink className={"btn btn-primary max-rounded d-block d-lg-inline-block m-3 w-45"}
                                     href={quittance.memo_link}>
                                <i className={'fas fa-file-pdf'}/> Télécharger le Mémo Véhicule Assuré
                            </APILink>
                        }

                        {quittance?.attestation_assurance_link &&
                            <APILink className={"btn btn-primary max-rounded d-block d-lg-inline-block m-3 w-45"}
                                     href={quittance.attestation_assurance_link}>
                                <i className={'fas fa-file-pdf'}/> Télécharger l'Attestation d'assurance
                            </APILink>
                        }

                        {(quittance?.attestation_rc_circuit_link) &&
                            <APILink className={"btn btn-primary max-rounded d-block d-lg-inline-block m-3 w-45"}
                                     href={quittance.attestation_rc_circuit_link}>
                                Télécharger l'attestation RC Roulage Circuit
                            </APILink>
                        }
                    </>
                }
                {
                    contract.ri_link && !_.startsWith(contract.vehicule.codeProduit, '229127_') && <div className={'col-12 col-sm-6 mt-3 px-3'}>
                        <p>Pour télécharger votre <b>Relevé d'Informations</b>, sélectionnez votre contrat, un motif puis cliquez sur le bouton
                            ci-dessous :</p>
                        <FormReleveInformation riLink={contract.ri_link} title={"Editer mon relevé d'informations"}/>
                    </div>
                }

                {isTransitoire && (
                    <div className="mt-4 mb-4">
                        <div className="d-flex align-items-center mb-2">
                            <h5 className={'m-0 d-inline-block fw-bold align-middle'}>Assurance transitoire
                                - {contract.old_vehicule?.marque} {contract.old_vehicule?.modele} {contract.old_vehicule?.immatriculation}</h5>
                                <span
                                    onClick={handleClickInfo}
                                    className="d-inline-block text-center bg-primary text-white rounded-circle"
                                    style={{
                                        cursor: 'pointer',
                                        width: '20px',
                                        height: '20px',
                                        lineHeight: '20px',
                                        marginLeft: '10px'
                                    }}
                                >
                                    ?
                                </span>
                        </div>
                        <p>L'assurance transitoire est actuellement activée sur ce véhicule. Pour télécharger le Mémo
                            Véhicule Assuré cliquez sur le bouton ci-dessous.</p>

                        {contract.old_vehicule?.memo_link && (
                            <APILink className={"btn btn-primary max-rounded d-block d-lg-inline-block my-3 w-45"}
                                     href={contract.old_vehicule?.memo_link}>
                                <i className={'fas fa-file-pdf'}/> Télécharger le Mémo Véhicule Assuré
                            </APILink>
                        )}
                    </div>
                )}
            </SelectContractContainer>
        </div>
    );
};

export default ListeDocuments;
